export default {
    auto: 'Automation',
    planned: 'Planned',
    mass_mailing: 'Mass mailing',
};
